<input
  class="eg-input__input"
  [class.no-label]="!labelWithSuffix"
  [id]="id"
  type="text"
  mask="Hh:m0"
  [(ngModel)]="value"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [leadZeroDateTime]="true"
  [showMaskTyped]="false"
  (keyup)="onTimeChange($event.target['value'])"
  (blur)="markInputAsTouched()"
/>

<label [for]="id" class="absolute eg-input__label">
  {{ labelWithSuffix }}
</label>

<img class="absolute eg-input__suffix eg-input__suffix--icon" src="/assets/icons/clock.svg" alt="CLOCK" />

@if (control?.touched && control?.errors && errorMessage) {
  <eg-form-error [errorMessage]="errorMessage" class="eg-input__error"></eg-form-error>
}
